import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import SpinnerBox from "./SpinnerBox";
import OverlayContext from "../Overlay/Context";
const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.palette.background.overlay
  },
  absolute: {
    position: "absolute"
  },
  fixed: {
    position: "fixed",
    top: 0,
    left: 0
  }
}));

const SpinnerContainer = ({
  size,
  Component
}) => {
  const styles = useStyles();
  const {
    position
  } = React.useContext(OverlayContext);
  const stylesPosition = styles[position];
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.root, stylesPosition)
  }, /*#__PURE__*/React.createElement(Component, {
    color: "primary",
    size: size
  }));
};

SpinnerContainer.defaultProps = {
  Component: SpinnerBox
};
export default SpinnerContainer;